import { createReporter } from 'whisper-core-api';
const reporter = createReporter('[nudge-renderer-utils]');
export const captureMessage = reporter.captureMessage;
export const captureError = reporter.captureError;
export const captureWarn = (message, error, options) => {
  captureError(message, error, Object.assign({}, options, {
    level: 'warning'
  }));
};